import { AppRouteProps } from "@harea/component";
import { HeuresSupplementairesCreationRoutes } from "./views/create/HeuresSupplementairesCreationRoutes";
import HeuresSupplementairesListContainer from "./containers/HeuresSupplementairesContainer";

export const HeuresSupplementairesRoutes: Array<AppRouteProps> = [
  {
    path: "overtimes",
    element: <HeuresSupplementairesListContainer />,
    children: [...HeuresSupplementairesCreationRoutes],
  },
];
